import i18n from "@/shared/lib/i18n/index.ts";

/** Render an ISO timestamp as a compact relative label ("5s ago", "3m ago"). */
export function formatRelativeTime(iso: string, now: number = Date.now()): string {
  const diffMs = now - new Date(iso).getTime();
  const sec = Math.max(0, Math.floor(diffMs / 1000));
  if (sec < 60) return i18n.t("relativeTime.seconds", { ns: "alerts", n: sec });
  const min = Math.floor(sec / 60);
  if (min < 60) return i18n.t("relativeTime.minutes", { ns: "alerts", n: min });
  const hr = Math.floor(min / 60);
  if (hr < 24) return i18n.t("relativeTime.hours", { ns: "alerts", n: hr });
  const day = Math.floor(hr / 24);
  return i18n.t("relativeTime.days", { ns: "alerts", n: day });
}
